import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
// Import speIconMap et allFamilles_map_label_backend, domainIconMapRaw n'est plus utilisé ici pour les domaines
import { speIconMap, allFamilles_map_label_backend } from './domainIconMap'; 
import checkIcon from '../../assets/true_icon.png';
import crossIcon from '../../assets/attention_icon.png';
import infoIcon from '../../assets/info_gris_default.png'; // Import info icon
import flecheVioletteIcon from '../../assets/fleche_violette.png'; // Import purple arrow icon
import flecheVerteIcon from '../../assets/fleche_verte.png'; // Import green arrow icon - adjust path as needed
import PopupGlobaleOneChoice from '../PopupGlobaleOneChoice';

import lowIcon from '../../assets/chances_tres_basses.png'; // Import your icons
import belowAverageIcon from '../../assets/chances_basses.png';
import averageIcon from '../../assets/chances_basses.png'; // Note: Same as belowAverageIcon in original
import highIcon from '../../assets/true_icon.png';
import veryHighIcon from '../../assets/chances_tres_elevees.png';
import defaultIcon from '../../assets/dont_know_icon.png'; // Icon par défaut pour les domaines

import useDeviceType from '../useDeviceType';
import theme from '../../theme'; // Correct path

/* ==================================================== 
   FONCTIONS UTILITAIRES POUR LE CALCUL DU GRADIENT & DOMAINES
=====================================================*/
const chancesLevelMap = [
  { range: [0, 20], text: "Très Basses", icon: lowIcon },
  { range: [20, 40], text: "Basses", icon: belowAverageIcon },
  { range: [40, 60], text: "Moyennes", icon: averageIcon },
  { range: [60, 80], text: "Elevées", icon: highIcon },
  { range: [80, 100], text: "Très élevées", icon: veryHighIcon }
];

// Fonction pour obtenir les détails d'un domaine (nom, icône) à partir de son hierarchyCode
// Utilisant formacodeData et hierarchyCodeToIconMap passés en props
const getDomainDetailsForCorrespondance = (hierarchyCode, formacodeData, hierarchyCodeToIconMap) => {
  if (!hierarchyCode || !formacodeData || !formacodeData.formacodes || !hierarchyCodeToIconMap) {
    return { name: hierarchyCode || 'Domaine inconnu', icon: defaultIcon, originalCode: hierarchyCode };
  }

  const formacodeEntry = formacodeData.formacodes.find(fc => fc.hierarchyCode === hierarchyCode);
  
  let icon = defaultIcon;
  // Essayer de trouver l'icône : d'abord par code exact, puis par parent de 4 caractères
  if (hierarchyCodeToIconMap.has(hierarchyCode)) {
    icon = hierarchyCodeToIconMap.get(hierarchyCode);
  } else if (hierarchyCode.length >= 4 && hierarchyCodeToIconMap.has(hierarchyCode.substring(0, 4))) {
    icon = hierarchyCodeToIconMap.get(hierarchyCode.substring(0, 4));
  }
  
  if (formacodeEntry) {
    return {
      name: formacodeEntry.descriptorRich || formacodeEntry.descriptor || 'Domaine inconnu',
      icon: icon,
      originalCode: hierarchyCode
    };
  }

  // Fallback si hierarchyCode non trouvé dans formacodeData.formacodes
  // Essayer de trouver un nom de parent au moins
  if (hierarchyCode.length >= 4) {
      const parentHierarchyCode = hierarchyCode.substring(0, 4);
      const parentEntry = formacodeData.formacodes.find(fc => fc.hierarchyCode === parentHierarchyCode);
      if (parentEntry) {
          return {
              name: `Sous-domaine de ${parentEntry.descriptorRich || parentEntry.descriptor || 'Domaine parent inconnu'} (${hierarchyCode})`,
              icon: icon, 
              originalCode: hierarchyCode
          };
      }
  }
  
  return { name: hierarchyCode || 'Domaine inconnu', icon: icon, originalCode: hierarchyCode };
};


/* ====================================================
   STYLED-COMPONENTS POUR LA STRUCTURE
=====================================================*/

/* ---------- Composant Gauge ---------- */

const GaugeWrapper = styled.div`
  position: relative;
  width: 200px;
  height: 120px;
  margin-top: 10px;
`;

const SvgStyled = styled.svg`
  overflow: visible;
`;

/* ---------- Card générique ---------- */
const Card = styled.div`
  width: 100%;
  background: white;
  border-radius: 25px;
  padding: 20px;
  margin: 10px 0;
  border: 1px solid ${theme.colors.gris_clair_default};
  position: relative;
`;

const CardTitle = styled.div`
  color: black;
  font-size: 16px;
  font-family: 'Gabarito', sans-serif;
  font-weight: 400;
  text-align: left;
`;

const ScoreCenterWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const InfoIconGauge = styled.img`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 10;
`;

/* ---------- Séparateur ---------- */
const Separator = styled.div`
  width: 100%;
  height: 1px;
  border: 1.5px solid ${theme.colors.background};
  margin: 10px 0;
`;

/* ---------- Liste des domaines ---------- */
const DomainList = styled.div`
  margin-top: 10px;
`;

const DomainItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const DomainIcon = styled.img`
  width: 35px;
  height: 35px;
  background: none;
  border-radius: 4px;
  flex-shrink: 0;
  // img nested selector removed as DomainIcon is already an img
  object-fit: cover; // Added directly to DomainIcon
`;

// DefaultDomainIcon n'est plus nécessaire si getDomainDetailsForCorrespondance fournit toujours une icône
// const DefaultDomainIcon = styled.div`...`;

const DomainName = styled.div`
  color: black;
  font-size: 13px;
  font-family: 'Gabarito', sans-serif;
  font-weight: 400;
  margin-left: 10px;
`;

const VoirPlusButton = styled.div`
  width: fit-content;
  color: rgba(130, 128, 128, 0.7);
  font-size: 14px;
  font-family: 'Geologica', sans-serif;
  font-style: italic;
  font-weight: 300;
  cursor: pointer;
  margin-left: 75%;
  &:hover {
    text-decoration: underline;
  }
`;

/* ---------- Liste pour le caractère ---------- */
const ListSection = styled.div`
  margin-top: 10px;
  text-align: left;
`;

const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
`;

const IconCheck = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 10px;
  margin-top: 2px;
`;

const IconCross = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 10px;
`;

const ListText = styled.div`
  color: black;
  font-size: 13px;
  font-family: 'Gabarito', sans-serif;
  font-weight: 400;
`;

/* ====================================================
   NOUVEAUX COMPOSANTS POUR LES SPÉCIALITÉS
=====================================================*/

// Container pour les spécialités
const SpecialtyContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  width: 100%;
  padding: 10px 0;
  flex-wrap: wrap;
`;

// Conteneur pour chaque spécialité
const SpecialtyItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  width: 30%;
`;

// Barre verticale pour les spécialités
const VerticalBar = styled.div`
  position: relative;
  width: 17px;
  height: 200px;
  border-radius: 30px;
  background: #DCF3FF;
  margin-bottom: 30px;
`;

// Filling de la barre verticale
const VerticalBarFill = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: ${props => props.max ? `${(props.max - props.rank + 1) / props.max * 100}%` : '50%'};
  border-radius: 30px;
  background: #38B6FF;
`;

// Badge de position
const PositionBadge = styled.div`
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 28px;
  border-radius: 25px;
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  font-family: Gabarito, sans-serif;
  font-size: 16px;
  font-weight: 400;
`;

// Conteneur pour l'icône et le texte de spécialité
const SpecialtyInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  margin-top: 5px;
`;

// Icône de spécialité
const SpecialtyIcon = styled.img`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-right: 3px;
`;

// Conteneur pour les textes de spécialité (label et nom)
const SpecialtyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

// Label "Spécialité"
const SpecialtyLabel = styled.div`
  color: #B6B6B6;
  font-family: Gabarito, sans-serif;
  font-size: 14px;
  font-weight: 400;
`;

// Nom de la spécialité
const SpecialtyName = styled.div`
  color: #000;
  font-family: Gabarito, sans-serif;
  font-size: 19px;
  font-weight: 400;
`;

// Message d'information sous les spécialités
const InfoMessage = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 15px;
  width: 100%;
  justify-content: flex-start;
  text-align: left;
  padding-left: 10px;
`;

const InfoIconStyled = styled.img` // Renamed to avoid conflict with imported infoIcon
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  margin-right: 10px;
`;

const InfoText = styled.div`
  color: #8D8D8D;
  font-family: Gabarito, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
`;

/* ====================================================
   NOUVEAUX COMPOSANTS POUR LA MOYENNE
=====================================================*/

const GradeTitle = styled.div`
  color: black;
  font-size: 16px;
  font-family: 'Gabarito', sans-serif;
  font-weight: 400;
  margin-bottom: 20px;
  text-align: left;
`;

const GradeBarContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px;
  margin: 0px 0;
`;

const HorizontalBar = styled.div`
  position: relative;
  width: 100%;
  height: 18px;
  border-radius: 30px;
  background: #DCF3FF;
`;

const GradeMarker = styled.div`
  position: absolute;
  top: 50%;
  left: ${props => (props.position / 20) * 100}%;
  transform: translate(-50%, -50%);
  width: 3px;
  height: 18px;
  border-radius: 30px;
  background: ${props => props.color};
  z-index: 2;
`;

const GradeLabel = styled.div`
  position: absolute;
  top: ${props => props.isUser ? '100px' : '30px'};
  left: ${props => (props.position / 20) * 100}%;
  transform: translateX(-50%);
  color: ${props => props.color};
  text-align: center;
  font-family: Gabarito, sans-serif;
  font-size: 15px;
  font-weight: 400;
`;


const SpecialtySection = styled.div`
  width: 100%;
`;

const GradeSection = styled.div`
  width: 100%;
  margin-top: 20px;
`;

/* ====================================================
   NOUVEAUX COMPOSANTS POUR LES CHANCES D'ADMISSION
=====================================================*/

const AdmissionContainer = styled.div`
  width: 100%;
  background: #FF2768;
  border-radius: 25px;
  padding: 20px;
  margin: 10px 0px 0px 0px;
  box-shadow: 0px 0px 0px 0px #D42359;
`;

const AdmissionTitle = styled.div`
  color: #FFF;
  font-family: Gabarito;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
`;

const AdmissionProgressContainer = styled.div`
  width: 100%;
  height: 15px;
  flex-shrink: 0;
  background: #FFF;
  border-radius: 25px;
  overflow: hidden;
  margin-bottom: 15px;
`;

const AdmissionProgressFill = styled.div`
  height: 100%;
  width: ${props => props.percentage}%;
  background: linear-gradient(90deg, #FF0000 0%, #FFFF00 50%, #26FF00 100%);
  border-radius: 25px;
`;

const AdmissionInfoMessage = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
`;

const AdmissionInfoText = styled.div`
  color: #FFF;
  font-family: Gabarito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
`;

const FloatingButton = styled.button`
  position: fixed;
  bottom: ${props => props.pressed ? '16px' : '20px'};
  // left: 50%;
  // transform: translateX(-50%);
  width: 280px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 25px;
  background: #FF2768;
  box-shadow: ${props => props.pressed ? 'none' : '0px 4px 0px 0px #D42359'};
  border: none;
  color: white;
  font-family: Gabarito;
  font-size: 16px;
  cursor: pointer;
  z-index: 1000;
  display: ${props => props.show ? 'block' : 'none'};
  transition: bottom 0.05s ease, box-shadow 0.05s ease;
  outline: none;
  opacity: 1; /* Explicitly set opacity to 100% */
  
  &:hover, &:focus {
    outline: none;
    opacity: 1; /* Maintain 100% opacity on hover/focus */
  }
`;

const AdmissionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
`;

const StatusBadge = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 25px;
  background: #FFF;
`;

const StatusText = styled.span`
  color: #000;
  font-family: Gabarito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 5px;
`;

const StatusIcon = styled.img`
  width: 20px;
  height: 20px;
`;

// Nouveau boutton pour compléter le dossier
const CompleteProfileButton = styled.button`
  width: 100%;
  height: 44px;
  border-radius: 25px;
  background: #FFF;
  border: none;
  color: #FF2768;
  font-family: Gabarito;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 15px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s, transform 0.1s;
  
  &:hover {
    background-color: #F7F7F7;
  }
  
  &:active {
    transform: translateY(1px);
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  }
`;

const getChancesLevel = (percentage) => {
  for (const level of chancesLevelMap) {
    if (percentage >= level.range[0] && percentage <= level.range[1]) {
      return level;
    }
  }
  return chancesLevelMap[2]; // "Moyenne" as default
};

/* ====================================================
   COMPOSANT PRINCIPAL
=====================================================*/
const DesktopGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns || '1fr 1fr'};
  grid-gap: 20px;
  width: 100%;
  margin-bottom: 20px;
`;

const GridFullWidth = styled.div`
  grid-column: 1 / -1;
  width: 100%;
`;

const CardGrid = styled(Card)`
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
`;

const CharacteristicsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
  width: 100%;
`;
const UnavailableText = styled.p`
  text-align: center;
  font-style: italic;
  color: #666;
  padding: 20px 0;
  font-family: Gabarito, sans-serif;
`;
/* ====================================================
   GAUGE UTILS
=====================================================*/
const getArcPath = (percentage) => {
  const angle = (percentage / 100) * 180;
  const radians = (angle * Math.PI) / 180;
  const x = 100 + 90 * Math.cos(Math.PI - radians);
  const y = 100 - 90 * Math.sin(Math.PI - radians);
  return `M 10,100 A 90,90 0 ${angle >= 180 ? 1 : 0} 1 ${x},${y}`;
};

const Gauge = ({ percentage }) => {
  const fullArcPath = 'M 10,100 A 90,90 0 0,1 190,100';
  const visibleArcPath = getArcPath(percentage);

  return (
    <GaugeWrapper>
      <SvgStyled width="200" height="140">
        <defs>
          <linearGradient
            id="scoreGradient"
            gradientUnits="userSpaceOnUse"
            x1="100" y1="10"
            x2="100" y2="190"
            gradientTransform="rotate(270, 100, 100)"
          >
            <stop offset="0%" stopColor="#ff0000" />
            <stop offset="26%" stopColor="#f4932c" />
            <stop offset="53%" stopColor="#f1e424" />
            <stop offset="79%" stopColor="#35de2f" />
            <stop offset="100%" stopColor="#26ff00" />
          </linearGradient>
        </defs>
        <path
          d={fullArcPath}
          fill="none"
          stroke="#D6D2D2"
          strokeWidth="20"
          strokeLinecap="round"
        />
        <path
          d={visibleArcPath}
          fill="none"
          stroke="url(#scoreGradient)"
          strokeWidth="20"
          strokeLinecap="round"
        />
        <text
          x="100"
          y="95"
          textAnchor="middle"
          fontSize="12"
          fontFamily="Gabarito, sans-serif"
          fill="#555454"
        >
          <tspan x="100" dy="0">Correspondance</tspan>
          <tspan x="100" dy="1.2em">avec la formation</tspan>
        </text>
        <text
          x="100"
          y="75"
          textAnchor="middle"
          fontSize="40"
          fontFamily="Gantari, sans-serif"
          fill="black"
          fontWeight="700"
        >
          {Math.round(percentage)}%
        </text>
      </SvgStyled>
    </GaugeWrapper>
  );
};

const CorrespondanceFormation = ({ formation, posNeg, headerHeight, formacodeData, hierarchyCodeToIconMap }) => {
  const { isMobile } = useDeviceType();
  const [showScoreInfoPopup, setShowScoreInfoPopup] = useState(false);

  const scoreInfoText = "Ce score représente la correspondance globale entre ton profil et cette formation. Il est calculé en prenant en compte tes domaines favoris, tes spécialités, ta moyenne, ton lycée, ton classement dans ta classe et ton quiz de personnalité.";
  
  const scoreFormations = formation?.score_formations || 0;
  let moyenne_générale = formation?.moyenne_formation || null;
  moyenne_générale = moyenne_générale === 0 ? null : moyenne_générale; 
  
  const admissionChances = formation?.chances_admissions !== undefined 
    ? Math.round(formation.chances_admissions * 100) 
    : 50; // default 50, -100 is pas d'info

  const normalizeString = (str) => {
    if (typeof str !== 'string') return '';
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const formationType = allFamilles_map_label_backend[formation.type] || formation.type;
  const normalizedFormationType = normalizeString(formationType);

  const filteredPositives = posNeg?.positive?.filter(item => 
    normalizeString(item.quiz_type) === normalizedFormationType
  ) || [];
  const filteredNegatives = posNeg?.negative?.filter(item => 
    normalizeString(item.quiz_type) === normalizedFormationType
  ) || [];
  
  const userObject = typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : {};
  const userMoyenne = userObject?.grades?.general || 5.5; 
  const userFavDomains = userObject?.sub_domaine_formation || []; 

  const domainesP_codes = formation.domaines_enseignés_principaux || [];
  const domainesS_codes = formation.domaines_enseignés_secondaires || [];

  const allFormationDomainCodes = [
    ...domainesP_codes.map(code => ({ code, type: 'principal' })),
    ...domainesS_codes.map(code => ({ code, type: 'secondaire' }))
  ];

  const processedFormationDomains = allFormationDomainCodes.map(d => {
    const details = getDomainDetailsForCorrespondance(d.code, formacodeData, hierarchyCodeToIconMap);
    let matchLevel = 3; 

    for (const favDomainCode of userFavDomains) {
      if (d.code === favDomainCode) {
        matchLevel = 0; 
        break; 
      }
      if (favDomainCode && d.code.substring(0, 4) === favDomainCode.substring(0, 4)) {
        matchLevel = Math.min(matchLevel, 1);
      }
      else if (favDomainCode && d.code.substring(0, 2) === favDomainCode.substring(0, 2)) {
         matchLevel = Math.min(matchLevel, 2);
      }
    }
    return { ...details, type: d.type, matchLevel };
  });

  processedFormationDomains.sort((a, b) => {
    if (a.matchLevel !== b.matchLevel) {
      return a.matchLevel - b.matchLevel; 
    }
    const typeOrder = { 'principal': 1, 'secondaire': 2 };
    if (typeOrder[a.type] !== typeOrder[b.type]) {
      return typeOrder[a.type] - typeOrder[b.type];
    }
    return a.name.localeCompare(b.name);
  });
  
  const isLyceeInfoMissing = !userObject?.lycee_city || !userObject?.lycee_name || !userObject?.lycee_uai;
  const isTopOptionMissing = !userObject?.top_option;
  const isProfileIncomplete = isLyceeInfoMissing || isTopOptionMissing;

  const handleCompleteProfile = () => {
    if (isLyceeInfoMissing) {
      window.location.href = "/profile/modify/lycee";
    } else if (isTopOptionMissing) {
      window.location.href = "/profile/modify/classe-ment";
    }
  };

  const obj_mapper_spé = {
      "bioeco": "Biologie/Ecologie", "hggsp": "HGGSP", "hlp": "HLP", "llcer": "LLCER",
      "lca": "LCA : Latin", "math": "Mathématiques", "nsi": "NSI", "physchim": "Physique-Chimie",
      "si": "SI", "svt": "SVT", "ses": "SES", "eppcs": "EPPCS", 'amc': "Anglais Monde Contemporain"
  };
  const obj_mapper_spé_short = {
    "bioeco": "Bio/Eco", "hggsp": "HGGSP", "hlp": "HLP", "llcer": "LLCER", "lca": "LCA",
    "math": "Maths", "nsi": "NSI", "physchim": "PC", "si": "SI", "svt": "SVT",
    "ses": "SES", "eppcs": "EPPCS", "amc": "AMC"
  };
  
  let userSpés = userObject?.specialites || [];
  const spéRank = formation?.rang_spécialité || {};
  const sortedSpésEntries = Object.entries(spéRank).sort(([, scoreA], [, scoreB]) => scoreB - scoreA);
  const sortedSpéNames = sortedSpésEntries.map(([name]) => name);
  const maxSpesRank = sortedSpéNames.length; 

  const MatchedSpecialitiesRankObj = userSpés.reduce((obj, spéShort) => {
    const spéFullName = obj_mapper_spé[spéShort] || spéShort; 
    const rank = sortedSpéNames.indexOf(spéFullName) + 1; 
    obj[spéShort] = rank; 
    return obj;
  }, {});
  
  const [showAllDomaines, setShowAllDomaines] = useState(false);
  const [showAllPositives, setShowAllPositives] = useState(false);
  const [showAllNegatives, setShowAllNegatives] = useState(false);

  const initialDomainCount = 2;
  const initialListCount = 3;

  const domainesToShow = showAllDomaines ? processedFormationDomains : processedFormationDomains.slice(0, initialDomainCount);
  const positivesToShow = showAllPositives ? filteredPositives : filteredPositives.slice(0, initialListCount);
  const negativesToShow = showAllNegatives ? filteredNegatives : filteredNegatives.slice(0, initialListCount);

  const admissionContainerRef = useRef(null);
  const [isContainerVisible, setIsContainerVisible] = useState(false);
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  useEffect(() => {
    if (!admissionContainerRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const isVisible = entries[0].isIntersecting;
        setIsContainerVisible(isVisible);
      },
      { root: null, rootMargin: isMobile ? '-150px 0px -150px 0px' : '0px 0px -100px 0px', threshold: isMobile ? 0.1 : 0.01 }
    );
    observer.observe(admissionContainerRef.current);
    return () => {
      if (admissionContainerRef.current) {
        observer.unobserve(admissionContainerRef.current);
      }
    };
  }, [isMobile, posNeg, formation]);

  const handleButtonClick = () => {
    setIsButtonPressed(true);
    if (admissionContainerRef.current) {
      admissionContainerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    setTimeout(() => setIsButtonPressed(false), 100);
  };

  const renderSpecialtyItem = (specialityName, rank, max) => {
    return (
      <SpecialtyItem key={specialityName}>
      <VerticalBar>
        {rank !== 0 && <VerticalBarFill rank={rank} max={max} />}
        <PositionBadge style={{ width: '100px' }}>
        {rank === 0 ? 'Absente' : `${rank}${rank === 1 ? 'ère' : 'ème'}`}
        </PositionBadge>
      </VerticalBar>
      <SpecialtyInfo>
        {speIconMap.find(item => item.value === specialityName)?.icon ? (
        <SpecialtyIcon
          src={speIconMap.find(item => item.value === specialityName)?.icon}
          alt={specialityName}
        />
        ) : (
        <div style={{ width: '100px', height: '32px', background: '#ccc', borderRadius: '50%' }}></div>
        )}
        <SpecialtyTextContainer>
        <SpecialtyLabel>Spécialité</SpecialtyLabel>
        <SpecialtyName>{obj_mapper_spé_short[specialityName] || specialityName}</SpecialtyName>
        </SpecialtyTextContainer>
      </SpecialtyInfo>
      </SpecialtyItem>
    );
  };

  // NOUVEAU: Textes pour informations non disponibles
  const noInfoText = {
    domaines: "Information sur les domaines enseignés non disponible.",
    quiz: "Information sur la correspondance (quiz) non disponible.",
    specialties: "Information sur la valorisation des spécialités non disponible.",
    moyenne: "Information sur la moyenne des admis non disponible.",
  };

  if (isMobile) {
    return (
      <Container headerHeight={headerHeight}>
        <Card>
          <CardTitle></CardTitle>
          <ScoreCenterWrapper>
            <InfoIconGauge 
              src={infoIcon} 
              alt="Info score" 
              onClick={() => {
                console.log("Info icon clicked! (Mobile)");
                setShowScoreInfoPopup(true);
              }} 
            />
            <Gauge percentage={scoreFormations} />
          </ScoreCenterWrapper>
        </Card>

        <Card>
          <CardTitle>Domaines enseignés</CardTitle>
          <Separator />
          {formation?.score_domaines === -1 ? (
            <UnavailableText>{noInfoText.domaines}</UnavailableText>
          ) : (
            <DomainList>
              {processedFormationDomains.length === 0 ? (
                <UnavailableText>Aucun domaine enseigné spécifié pour cette formation.</UnavailableText>
              ) : (
                domainesToShow.map((domainDetail, idx) => (
                  <DomainItem key={idx}>
                    <DomainIcon
                      src={domainDetail.icon}
                      alt={domainDetail.name}
                    />
                    <DomainName>{domainDetail.name}</DomainName>
                  </DomainItem>
                ))
              )}
              {processedFormationDomains.length > initialDomainCount && (
                <VoirPlusButton onClick={() => setShowAllDomaines(prev => !prev)}>
                  {showAllDomaines ? 'voir moins' : 'voir plus...'}
                </VoirPlusButton>
              )}
            </DomainList>
          )}
        </Card>

        <Card>
          <CardTitle>Pourquoi la formation te correspond</CardTitle>
          <Separator />
          {formation?.score_quiz === -1 ? (
             <UnavailableText>{noInfoText.quiz}</UnavailableText>
          ) : (
            <>
              {filteredPositives.length === 0 && filteredNegatives.length === 0 && (
                <UnavailableText>Aucun point de correspondance spécifique identifié pour cette formation.</UnavailableText>
              )}
              {filteredPositives.length > 0 && (
                <ListSection>
                  {positivesToShow.map((item, idx) => (
                    <ListItem key={`pos-${idx}`}>
                      <IconCheck src={checkIcon} alt="check" />
                      <ListText>{item.mot}</ListText>
                    </ListItem>
                  ))}
                  {filteredPositives.length > initialListCount && (
                    <VoirPlusButton onClick={() => setShowAllPositives(prev => !prev)}>
                      {showAllPositives ? 'voir moins' : 'voir plus...'}
                    </VoirPlusButton>
                  )}
                </ListSection>
              )}
              {filteredNegatives.length > 0 && (
                <ListSection>
                  {negativesToShow.map((item, idx) => (
                    <ListItem key={`neg-${idx}`}>
                      <IconCross src={crossIcon} alt="cross" />
                      <ListText>{item.mot}</ListText>
                    </ListItem>
                  ))}
                  {filteredNegatives.length > initialListCount && (
                    <VoirPlusButton onClick={() => setShowAllNegatives(prev => !prev)}>
                      {showAllNegatives ? 'voir moins' : 'voir plus...'}
                    </VoirPlusButton>
                  )}
                </ListSection>
              )}
            </>
          )}
        </Card>

        <Card>
          <CardTitle>Tes spécialités dans la formation</CardTitle>
          <Separator />
          {formation?.score_specialties === -1 ? (
            <UnavailableText>{noInfoText.specialties}</UnavailableText>
          ) : (
            userSpés.length > 0 ? (
              <SpecialtySection>
                <SpecialtyContainer>
                  {Object.entries(MatchedSpecialitiesRankObj)
                    .slice(0, 3)
                    .map(([specialityName, rank]) => renderSpecialtyItem(specialityName, rank, maxSpesRank))}
                </SpecialtyContainer>
                <InfoMessage>
                  <InfoIconStyled src={infoIcon} alt="Info" />
                  <InfoText>Rang de tes spécialités parmi les plus courantes chez les lycéens admis dans cette formation</InfoText>
                </InfoMessage>
              </SpecialtySection>
            ) : (
              <UnavailableText>Vous n'avez pas renseigné de spécialités dans votre profil.</UnavailableText>
            )
          )}
        </Card>

        <Card>
          <GradeTitle>Ta moyenne dans la formation</GradeTitle>
          <Separator />
          {formation?.score_moyenne === -1 ? (
            <UnavailableText>{noInfoText.moyenne}</UnavailableText>
          ) : (
            <GradeSection>
              <GradeBarContainer>
                <HorizontalBar />
                <GradeMarker position={moyenne_générale || 10} color="#C0F" />
                <GradeMarker position={userMoyenne} color="#4FEA2C" />
                <GradeLabel position={moyenne_générale || 10} color="#C0F" isUser={false}>
                  {Math.round((moyenne_générale || 10) * 10) / 10}/20
                </GradeLabel>
                <GradeLabel position={userMoyenne} color="#4FEA2C" isUser={true}>
                  {userMoyenne}/20
                </GradeLabel>
                {userMoyenne !== (moyenne_générale || 10) && ( // Correction ici pour éviter NaN avec null
                  <div
                    style={{
                      position: 'absolute', top: '50%',
                      left: `${Math.min(userMoyenne, moyenne_générale || 10) / 20 * 100}%`,
                      width: `${Math.abs(userMoyenne - (moyenne_générale || 10)) / 20 * 100}%`,
                      height: '18px', backgroundColor:' #38B6FF', borderRadius: '30px',
                      transform: 'translateY(-50%)', zIndex: 1
                    }}
                  />
                )}
              </GradeBarContainer>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '20px', gap: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <img src={flecheVioletteIcon} alt="Formation Average" style={{ width: '24px', height: '24px'}} />
                  <div style={{ color: '#8D8D8D', textAlign: 'left', fontFamily: 'Gabarito', fontSize: '14px', fontStyle: 'normal', fontWeight: 400, lineHeight: 'normal' }}>
                    Moyenne des étudiants admis dans la formation
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <img src={flecheVerteIcon} alt="Your Average" style={{ width: '24px', height: '24px'}} />
                  <div style={{ color: '#8D8D8D', textAlign: 'left', fontFamily: 'Gabarito', fontSize: '14px', fontStyle: 'normal', fontWeight: 400, lineHeight: 'normal' }}>
                    Ta moyenne générale
                  </div>
                </div>
              </div>
              <InfoMessage>
                <InfoIconStyled src={infoIcon} alt="Info" />
                <InfoText>Plus l'écart est petit, plus ton niveau scolaire correspond à celui des étudiants de la formation</InfoText>
              </InfoMessage>
            </GradeSection>
          )}
        </Card>

       <AdmissionContainer ref={admissionContainerRef}>
        <AdmissionHeader>
          <AdmissionTitle>Tes chances d'admission</AdmissionTitle>
          <StatusBadge>
            {admissionChances === -100 ? ( // -100 indique pas d'info
              <>
                <StatusText>Pas d'info</StatusText>
                <StatusIcon src="../../assets/info_gris.png" alt="Question mark" />
              </>
            ) : (
              <>
                <StatusText>{getChancesLevel(admissionChances).text}</StatusText>
                <StatusIcon src={getChancesLevel(admissionChances).icon} alt="Chances level" />
              </>
            )}
          </StatusBadge>
        </AdmissionHeader>
        {admissionChances === -100 ? (
          <>
            <AdmissionInfoMessage>
              <InfoIconStyled src={infoIcon} alt="Info" style={{ filter: 'brightness(0) invert(1)' }} />
              <AdmissionInfoText>
                Il n'y a pas assez de données pour estimer tes chances d'admission dans cette formation.
              </AdmissionInfoText>
            </AdmissionInfoMessage>
          </>
        ) : (
          <>
            <AdmissionProgressContainer>
              <AdmissionProgressFill percentage={admissionChances} />
            </AdmissionProgressContainer>
            <AdmissionInfoMessage>
              <InfoIconStyled src={infoIcon} alt="Info" style={{ filter: 'brightness(0) invert(1)' }} />
              <AdmissionInfoText>
                Cette estimation provient de calculs rigoureux basés sur ton profil et les statistiques passées de cette formation.
                Cela ne définit en aucun cas une décision future de l'établissement.
              </AdmissionInfoText>
            </AdmissionInfoMessage>
          </>
        )}
        
        {isProfileIncomplete && (
          <CompleteProfileButton onClick={handleCompleteProfile}>
            Compléter mon dossier
          </CompleteProfileButton>
        )}
      </AdmissionContainer>

      {admissionChances !== -100 && (
        <FloatingButton 
          show={!isContainerVisible}
          pressed={isButtonPressed}
          onClick={handleButtonClick}
        >
          Voir mes chances d'admission
        </FloatingButton>
      )}
        
        {showScoreInfoPopup && (
          <PopupGlobaleOneChoice
            isVisible={showScoreInfoPopup}
            message={scoreInfoText}
            onClose={() => setShowScoreInfoPopup(false)}
          />
        )}
      </Container>
    );
  } else {
    // Version desktop
    return (
      <Container headerHeight={headerHeight}>
        <DesktopGrid>
          <GridRow>
            <CardGrid style={{ maxWidth: '300px' }}>
              <CardTitle></CardTitle>
              <ScoreCenterWrapper>
                <InfoIconGauge
                  src={infoIcon}
                  alt="Info score"
                  onClick={() => {
                    console.log("Info icon clicked! (Desktop)");
                    setShowScoreInfoPopup(true);
                  }}
                />
                <Gauge percentage={scoreFormations} />
              </ScoreCenterWrapper>
            </CardGrid>
            
            <CardGrid>
              <CardTitle>Domaines enseignés</CardTitle>
              <Separator />
              {formation?.score_domaines === -1 ? (
                <UnavailableText>{noInfoText.domaines}</UnavailableText>
              ) : (
                <DomainList>
                  {processedFormationDomains.length === 0 ? (
                    <UnavailableText>Aucun domaine enseigné spécifié pour cette formation.</UnavailableText>
                  ) : (
                    domainesToShow.map((domainDetail, idx) => (
                      <DomainItem key={idx}>
                        <DomainIcon
                          src={domainDetail.icon}
                          alt={domainDetail.name}
                        />
                        <DomainName>{domainDetail.name}</DomainName>
                      </DomainItem>
                    ))
                  )}
                  {processedFormationDomains.length > initialDomainCount && (
                    <VoirPlusButton onClick={() => setShowAllDomaines(prev => !prev)}>
                      {showAllDomaines ? 'voir moins' : 'voir plus...'}
                    </VoirPlusButton>
                  )}
                </DomainList>
              )}
            </CardGrid>
          </GridRow>
          
          <GridRow>
            <GridFullWidth>
              <CardGrid>
                <CardTitle>Pourquoi la formation te correspond</CardTitle>
                <Separator />
                {formation?.score_quiz === -1 ? (
                  <UnavailableText>{noInfoText.quiz}</UnavailableText>
                ) : (
                  (filteredPositives.length === 0 && filteredNegatives.length === 0) ? (
                     <UnavailableText>Aucun point de correspondance spécifique identifié pour cette formation.</UnavailableText>
                  ) : (
                    <CharacteristicsGrid>
                      {filteredPositives.length > 0 && (
                        <ListSection>
                          {positivesToShow.map((item, idx) => (
                            <ListItem key={`pos-${idx}`}>
                              <IconCheck src={checkIcon} alt="check" />
                              <ListText>{item.mot}</ListText>
                            </ListItem>
                          ))}
                          {filteredPositives.length > initialListCount && (
                            <VoirPlusButton onClick={() => setShowAllPositives(prev => !prev)}>
                              {showAllPositives ? 'voir moins' : 'voir plus...'}
                            </VoirPlusButton>
                          )}
                        </ListSection>
                      )}
                      {filteredNegatives.length > 0 && (
                        <ListSection>
                          {negativesToShow.map((item, idx) => (
                            <ListItem key={`neg-${idx}`}>
                              <IconCross src={crossIcon} alt="cross" />
                              <ListText>{item.mot}</ListText>
                            </ListItem>
                          ))}
                          {filteredNegatives.length > initialListCount && (
                            <VoirPlusButton onClick={() => setShowAllNegatives(prev => !prev)}>
                              {showAllNegatives ? 'voir moins' : 'voir plus...'}
                            </VoirPlusButton>
                          )}
                        </ListSection>
                      )}
                    </CharacteristicsGrid>
                  )
                )}
              </CardGrid>
            </GridFullWidth>
          </GridRow>
          
          <GridRow>
            <CardGrid>
              <CardTitle>Tes spécialités dans la formation</CardTitle>
              <Separator />
              {formation?.score_specialties === -1 ? (
                <UnavailableText>{noInfoText.specialties}</UnavailableText>
              ) : (
                userSpés.length > 0 ? (
                  <SpecialtySection>
                    <SpecialtyContainer>
                      {Object.entries(MatchedSpecialitiesRankObj)
                        .slice(0, 3) 
                        .map(([specialityName, rank]) => renderSpecialtyItem(specialityName, rank, maxSpesRank))}
                    </SpecialtyContainer>
                    <InfoMessage>
                      <InfoIconStyled src={infoIcon} alt="Info" />
                      <InfoText>Rang de tes spécialités parmi les plus courantes chez les lycéens admis dans cette formation</InfoText>
                    </InfoMessage>
                  </SpecialtySection>
                ) : (
                  <UnavailableText>Vous n'avez pas renseigné de spécialités dans votre profil.</UnavailableText>
                )
              )}
            </CardGrid>
            
            <CardGrid>
              <GradeTitle>Ta moyenne dans la formation</GradeTitle>
              <Separator />
              {formation?.score_moyenne === -1 ? (
                <UnavailableText>{noInfoText.moyenne}</UnavailableText>
              ) : (
                <GradeSection>
                  <GradeBarContainer>
                    <HorizontalBar />
                    <GradeMarker position={moyenne_générale || 10} color="#C0F" />
                    <GradeMarker position={userMoyenne} color="#4FEA2C" />
                    <GradeLabel position={moyenne_générale || 10} color="#C0F" isUser={false}>
                      {Math.round((moyenne_générale || 10) * 10) / 10}/20
                    </GradeLabel>
                    <GradeLabel position={userMoyenne} color="#4FEA2C" isUser={true}>
                      {userMoyenne}/20
                    </GradeLabel>
                    {userMoyenne !== (moyenne_générale || 10) && ( // Correction ici
                      <div
                        style={{
                          position: 'absolute', top: '50%',
                          left: `${Math.min(userMoyenne, moyenne_générale || 10) / 20 * 100}%`,
                          width: `${Math.abs(userMoyenne - (moyenne_générale || 10)) / 20 * 100}%`,
                          height: '18px', backgroundColor:' #38B6FF', borderRadius: '30px',
                          transform: 'translateY(-50%)', zIndex: 1
                        }}
                      />
                    )}
                  </GradeBarContainer>
                  <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '20px', gap: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <img src={flecheVioletteIcon} alt="Formation Average" style={{ width: '24px', height: '24px'}} />
                      <div style={{ color: '#8D8D8D', textAlign: 'left', fontFamily: 'Gabarito', fontSize: '14px', fontStyle: 'normal', fontWeight: 400, lineHeight: 'normal' }}>
                        Moyenne des étudiants admis dans la formation
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <img src={flecheVerteIcon} alt="Your Average" style={{ width: '24px', height: '24px'}} />
                      <div style={{ color: '#8D8D8D', textAlign: 'left', fontFamily: 'Gabarito', fontSize: '14px', fontStyle: 'normal', fontWeight: 400, lineHeight: 'normal' }}>
                        Ta moyenne générale
                      </div>
                    </div>
                  </div>
                  <InfoMessage>
                    <InfoIconStyled src={infoIcon} alt="Info" />
                    <InfoText>Plus l'écart est petit, plus ton niveau scolaire correspond à celui des étudiants de la formation</InfoText>
                  </InfoMessage>
                </GradeSection>
              )}
            </CardGrid>
          </GridRow>
          
          <GridRow>
            <GridFullWidth>
              <AdmissionContainer ref={admissionContainerRef}>
                <AdmissionHeader>
                  <AdmissionTitle>Tes chances d'admission</AdmissionTitle>
                  <StatusBadge>
                    {admissionChances === -100 ? (
                        <>
                          <StatusText>Pas d'info</StatusText>
                          <StatusIcon src={infoIcon} alt="Question mark" />
                        </>
                      ) : (
                        <>
                          <StatusText>{getChancesLevel(admissionChances).text}</StatusText>
                          <StatusIcon src={getChancesLevel(admissionChances).icon} alt="Chances level" />
                        </>
                    )}
                  </StatusBadge>
                </AdmissionHeader>
                {admissionChances === -100 ? (
                    <>
                      <AdmissionInfoMessage>
                        <InfoIconStyled src={infoIcon} alt="Info" style={{ filter: 'brightness(0) invert(1)' }} />
                        <AdmissionInfoText>
                          Il n'y a pas assez de données pour estimer tes chances d'admission dans cette formation.
                        </AdmissionInfoText>
                      </AdmissionInfoMessage>
                    </>
                  ) : (
                    <>
                      <AdmissionProgressContainer>
                        <AdmissionProgressFill percentage={admissionChances} />
                      </AdmissionProgressContainer>
                      <AdmissionInfoMessage>
                        <InfoIconStyled src={infoIcon} alt="Info" style={{ filter: 'brightness(0) invert(1)' }} />
                        <AdmissionInfoText>
                          Cette estimation provient de calculs rigoureux basés sur ton profil et les statistiques passées de cette formation.
                          Cela ne définit en aucun cas une décision future de l'établissement.
                        </AdmissionInfoText>
                      </AdmissionInfoMessage>
                    </>
                )}
                {isProfileIncomplete && (
                  <CompleteProfileButton onClick={handleCompleteProfile}>
                    Compléter mon dossier
                  </CompleteProfileButton>
                )}
              </AdmissionContainer>
            </GridFullWidth>
          </GridRow>
        </DesktopGrid>
        
        {admissionChances !== -100 && (
          <FloatingButton 
            show={!isContainerVisible}
            pressed={isButtonPressed}
            onClick={handleButtonClick}
            style={{ marginLeft: 'auto', marginRight: 'auto'}}
          >
            Voir mes chances d'admission
          </FloatingButton>
        )}
        
        {showScoreInfoPopup && (
          <PopupGlobaleOneChoice
            isVisible={showScoreInfoPopup}
            message={scoreInfoText}
            onClose={() => setShowScoreInfoPopup(false)}
          />
        )}
      </Container>
    );
  }
};

export default CorrespondanceFormation;